import { FlowContext } from 'src/lib/flow';
import { composePage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

import { isAgent } from '../../../../lib/flow/pageHelpers';
import priceEstimatePage from '../default/priceEstimatePage';

function isEnabled({ answers, inputContext: { eligibleProducts, channel } }: FlowContext) {
  const eligibleForExclusives = eligibleProducts.includes('sell_with_exclusives');
  if (isAgent(answers, channel)) {
    return false;
  }
  return eligibleForExclusives;
}

export default composePage(priceEstimatePage, {
  title: () => 'How much do you think your home is worth today?',
  isEnabled,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.price_estimate_range',
      type: 'range',
      optional: false,
      minLabel: 'Minimum',
      maxLabel: 'Maximum',
    },
  ],
});
